import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';

import { ServiceProvider } from '@models';
import { UtilService } from '@services';
import { fetchCurrentServiceProviderAdmins } from '@state';
import { AdminDialog } from '../admin-dialog/admin.dialog';

@Component({
  selector: 'app-service-provider-admins',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatTooltipModule,
  ],
  templateUrl: './service-provider-admins.component.html',
  styleUrl: './service-provider-admins.component.scss',
})
export class ServiceProviderAdminsComponent implements OnInit {
  readonly dialog = inject(MatDialog);

  // columns: string[] = ['date', 'email', 'actions'];
  columns: string[] = ['date', 'email'];

  @Input() serviceProvider: ServiceProvider = new ServiceProvider();

  constructor(private store: Store, public utils: UtilService) {}

  async ngOnInit(): Promise<void> {
    this.store.dispatch(fetchCurrentServiceProviderAdmins());
  }

  onAddAdminClicked(): void {
    this.dialog.open(AdminDialog, {
      data: { serviceProvider: this.serviceProvider },
    });
  }
}
